<template>
  <div>
    <training-toolbar/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo"
        :title="$t('message.applyActivitiesTrainer')"
        :iconName="'file-person'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <template>
          <apply-activities-trainer-table :apply-activities="this.applyActivities" />
        </template>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import ApplyActivitiesTrainerTable from "@/components/applyActivities/applyActivitiesTrainerTable";
import TrainingToolbar from '../../components/common/trainingToolbar.vue';

export default {
  components: {
    ApplyActivitiesTrainerTable,
    CardHeader,
    TrainingToolbar
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        this.$store.state.userInfo = this.userInfo;
        this.getApplyActivities();
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      applyActivities: null
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchRoles() {
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    },
    getApplyActivities() {
      trainingService.getApplyActivities(null, this.$route.params.id).then(
        (response) => {
          this.applyActivities = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    }
  }
}
</script>